import { createAction } from 'redux-actions';
import getDynoGuid from 'ui-forms-editor-automation-lib/selectors/dynoSelectors/getDynoGuid';
import putSubscriptionsBulk from '../api/putSubscriptionsBulk';
import getEspSubscriptionsByEspListId from 'ui-forms-editor-automation-lib/selectors/subscriptions/getEspSubscriptionsByEspListId';
export const REQUEST_UPDATE_SUBSCRIPTIONS = '@@lib/REQUEST_UPDATE_SUBSCRIPTIONS';
export const SUCCESS_UPDATE_SUBSCRIPTIONS = '@@lib/SUCCESS_UPDATE_SUBSCRIPTIONS';
export const FAIL_UPDATE_SUBSCRIPTIONS = '@@lib/FAIL_UPDATE_SUBSCRIPTIONS';
const requestUpdateSubscriptions = createAction(REQUEST_UPDATE_SUBSCRIPTIONS);
const successUpdateSubscriptions = createAction(SUCCESS_UPDATE_SUBSCRIPTIONS);
const failUpdateSubscriptions = createAction(FAIL_UPDATE_SUBSCRIPTIONS);
const updateSubscriptionsBulk = () => (dispatch, getState) => {
  const state = getState();
  const dynoGuid = getDynoGuid(state);
  const subscriptions = getEspSubscriptionsByEspListId(state);
  dispatch(requestUpdateSubscriptions());
  return putSubscriptionsBulk(dynoGuid, subscriptions).then(() => {
    dispatch(successUpdateSubscriptions());
  }).catch(() => {
    dispatch(failUpdateSubscriptions());
  });
};
export default updateSubscriptionsBulk;